import React, { Component } from 'react';
import ReadOnlyInput from './c_readonly_input';
import Lang from '../../../i18n'
import { withRouter } from 'react-router-dom'

class OverviewGroup extends Component{
  render() {
    const styles = this.props.styles;
    const infoIcon = this.props.icon;
    const currency = this.props.currency;
    const deviceData = this.props.deviceData;
    const inkData = this.props.inkData;
    const ink = this.props.ink;

    const gtxPrinter = deviceData.filter(item => item.id === 1)[0];
    const transferPress = deviceData.filter(item => item.id === 2)[0];
    const pretreatMaker = deviceData.filter(item => item.id === 3)[0];
    const pretreatMakerLine = deviceData.filter(item => item.id === 4)[0];
    const dryer = deviceData.filter(item => item.id === 5)[0];

    const inkWhite = inkData.filter(item => item.id === 1)[0];
    const inkCmyk = inkData.filter(item => item.id === 2)[0];

    const helpTextCMYK = `Hier erfahren Sie die Tintenkosten (CMYK) pro ${ink.name} ml.`
    const helpTextWhite = `Hier erfahren Sie die Tintenkosten (weiß) pro ${ink.name} ml.`

    return(
      <div>
        {gtxPrinter !== undefined &&
          <ReadOnlyInput
            value={gtxPrinter.qty > 0 ? gtxPrinter.unit_price : 0}
            description={Lang.translate(`calculator:${gtxPrinter.localeName}`, this.props.location.pathname)}
            styles={styles}
            icon={infoIcon}
            fullWidth="true"
            currency={currency}
            helpText="Hier erfahren Sie die Kosten für den GTX Printer."
          />
        }

          {pretreatMaker !== undefined &&
            <ReadOnlyInput
              value={pretreatMaker.qty > 0 ? pretreatMaker.unit_price : 0}
              description={Lang.translate(`calculator:${pretreatMaker.localeName}`, this.props.location.pathname)}
              styles={styles}
              icon={infoIcon}
              currency={currency}
              helpText="Hier erfahren Sie die Pretreatmakerkosten."
            />
          }

          {transferPress !== undefined &&
            <ReadOnlyInput
              value={transferPress.qty > 0 ? transferPress.unit_price : 0}
              description={Lang.translate(`calculator:${transferPress.localeName}`, this.props.location.pathname)}
              styles={styles}
              icon={infoIcon}
              currency={currency}
              helpText="Hier erfahren Sie die Transferpressekosten."
            />
          }

          {inkCmyk !== undefined &&
            <ReadOnlyInput
              value={inkCmyk.price}
              unitInfo={ink.name + "ml"}
              description={Lang.translate(`calculator:inkCMYK`, this.props.location.pathname)}
              styles={styles}
              icon={infoIcon}
              currency={currency}
              helpText={helpTextCMYK}
            />
          }

          {pretreatMakerLine !== undefined &&
            <ReadOnlyInput
              value={pretreatMakerLine.qty > 0 ? pretreatMakerLine.unit_price : 0}
              description={Lang.translate(`calculator:${pretreatMakerLine.localeName}`, this.props.location.pathname)}
              styles={styles}
              icon={infoIcon}
              currency={currency}
              helpText="Hier erfahren Sie die Pretreatmaker LINE Kosten."
            />
          }

          {dryer !== undefined &&
            <ReadOnlyInput
              value={dryer.qty > 0 ? dryer.unit_price : 0}
              description={Lang.translate(`calculator:${dryer.localeName}`, this.props.location.pathname)}
              styles={styles}
              icon={infoIcon}
              currency={currency}
              helpText="Hier erfahren Sie die Tunneltrocknerkosten."
            />
          }

          {inkWhite !== undefined &&
            <ReadOnlyInput
              value={inkWhite.price}
              unitInfo={ink.name + "ml"}
              description={Lang.translate(`calculator:inkWhite`, this.props.location.pathname)}
              styles={styles}
              icon={infoIcon}
              currency={currency}
              helpText={helpTextWhite}
            />
          }
      </div>
    );
  }
}

export default withRouter(OverviewGroup);



// WEBPACK FOOTER //
// ./src/components/calculator/inputs/c_overview_group.js